import React from "react"
import PropTypes from "prop-types"
import { Note } from "@kit/design/note"

const PLAN_TERMS = {
  year: "Pro annual for your first year",
  month: "Pro for 12 months"
}

// The campaign's coupons expire at the end of the day Eastern, so every
// creator sees that date wherever they are.
function formatDeadline(endsAt) {
  return new Date(endsAt).toLocaleDateString("en-US", {
    timeZone: "America/New_York",
    month: "short",
    day: "numeric"
  })
}

export function SignalsLaunchOfferNote({ offer, children }) {
  const { percentOff, targetInterval, endsAt } = offer
  const deadline = endsAt ? ` before ${formatDeadline(endsAt)}` : ""

  return (
    <Note layout="inline">
      <Note.Icon name="percent-discount" />
      <Note.Content>
        <Note.Heading>NEW: Subscriber Signals.</Note.Heading>
        <p>
          See the hidden reach of your email list. Unlock it with {percentOff}%
          off {PLAN_TERMS[targetInterval]}
          {deadline}.
        </p>
      </Note.Content>
      {children}
    </Note>
  )
}

SignalsLaunchOfferNote.propTypes = {
  offer: PropTypes.shape({
    percentOff: PropTypes.number.isRequired,
    targetInterval: PropTypes.oneOf(Object.keys(PLAN_TERMS)).isRequired,
    endsAt: PropTypes.string
  }).isRequired,
  children: PropTypes.node
}
